import { CheckCircle, AlertTriangle, XCircle, HelpCircle } from 'lucide-react';
import type { ProjectStatus } from '../types';
import clsx from 'clsx';

interface StatusBadgeProps {
  status: ProjectStatus;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const statusConfig = {
  OK: {
    icon: CheckCircle,
    label: 'OK',
    color: 'text-green-500',
    bgColor: 'bg-green-100',
  },
  WARNING: {
    icon: AlertTriangle,
    label: 'Warnung',
    color: 'text-yellow-500',
    bgColor: 'bg-yellow-100',
  },
  ERROR: {
    icon: XCircle,
    label: 'Fehler',
    color: 'text-red-500',
    bgColor: 'bg-red-100',
  },
  UNKNOWN: {
    icon: HelpCircle,
    label: 'Unbekannt',
    color: 'text-gray-500',
    bgColor: 'bg-gray-100',
  },
};

const sizeConfig = {
  sm: {
    icon: 'w-4 h-4',
    text: 'text-xs',
    padding: 'px-2 py-1',
  },
  md: {
    icon: 'w-5 h-5',
    text: 'text-sm',
    padding: 'px-3 py-1.5',
  },
  lg: {
    icon: 'w-6 h-6',
    text: 'text-base',
    padding: 'px-4 py-2',
  },
};

export default function StatusBadge({
  status,
  showLabel = true,
  size = 'md',
}: StatusBadgeProps) {
  const config = statusConfig[status];
  const sizes = sizeConfig[size];
  const Icon = config.icon;

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full font-medium',
        config.bgColor,
        config.color,
        sizes.padding,
        sizes.text
      )}
    >
      <Icon className={sizes.icon} />
      {showLabel && <span>{config.label}</span>}
    </span>
  );
}
